import React from 'react'
import FlexBox from '../../flexBox/FlexBox'
import FormFieldLabel from '../formField/FormFieldLabel'
import { FormFieldGroupProps } from './_props'
import { getFormFieldContainerSx } from '../_utils/utils'

const FormFieldGroup: React.FC<FormFieldGroupProps> = ({ children, size = '0.5', ...labelProps }) => (
    <FlexBox sx={getFormFieldContainerSx(size)} flexDirection="column">
        <FormFieldLabel {...labelProps} />
        <FlexBox sx={{ width: '100%' }} flexDirection="column" gap=".4rem">
            {children}
        </FlexBox>
    </FlexBox>
)

export default FormFieldGroup
